import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppContext } from "../../../AppContext";
import { useApiQuery } from "../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { IStudioSettingsModel } from "../../../common/models/IStudioSettingsModel";

export interface IInventoryCategoryModel {
  id: number;
  name: string;
  emoji: string;
  sortOrder: number;
  isDeleted: boolean;
}

export interface IInventoryItemModel {
  id: number;
  name: string;
  brand: string | null;
  sku: string | null;
  barcode: string | null;
  price: number;
  costPrice: number;
  currentQuantity: number;
  lowStockThreshold: number;
  categoryId: number | null;
  sortOrder: number;
  isDeleted: boolean;
  unitOfMeasure: number;
}

export interface ICategorizedInventoryData {
  categories: IInventoryCategoryModel[];
  items: IInventoryItemModel[];
}

export const useCashdeskPage = () => {
  const { selectedStudioId } = useAppContext();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.has("orderId") ? 1 : 0);

  const { data: studioSettings, isLoading: isSettingsLoading } =
    useApiQuery<IStudioSettingsModel>({
      queryKey: [endpointsMetadata.studio.getStudioSettings, selectedStudioId],
      endpoint: endpointsMetadata.studio.getStudioSettings,
      enabled: selectedStudioId > 0,
    });

  const { data: categorizedData, isLoading: isProductsLoading } =
    useApiQuery<ICategorizedInventoryData>({
      queryKey: [
        endpointsMetadata.inventoryItemNomenclature.getAllCategorized,
        selectedStudioId,
      ],
      endpoint:
        endpointsMetadata.inventoryItemNomenclature.getAllCategorized,
      enabled: selectedStudioId > 0,
    });

  return {
    activeTab,
    setActiveTab,
    studioSettings,
    isSettingsLoading,
    categorizedData,
    isProductsLoading,
  };
};
